// src/components/settings/catalog/CatalogFolderPicker.js
// CATALOG SCREEN VERIFIER: catscreen-7a2c4e91 — Settings › Catalog, Stage 4.
//
// Choose one folder from the tree (parents before children, indented). Used by "Move to folder" /
// "Add to folder" in the bulk bar and by "Move folder…". `exclude` leaves folders out (a folder
// being moved and everything inside it); `topLevel` adds "Top level (no parent folder)".
import React from 'react';
import { Folder, Layers } from 'lucide-react';
import { flatFolders } from '../../../utils/catalogUi';

/** The folder and every folder inside it (loop-safe). */
export function folderAndBelow(tree, id) {
    const out = new Set();
    const walk = (fid) => {
        if (out.has(fid)) return;
        out.add(fid);
        for (const c of tree.children(fid)) walk(c.id);
    };
    walk(id);
    return out;
}

export const TOP_LEVEL = '__top';

export default function CatalogFolderPicker({ tree, value, onChange, exclude, topLevel, hereId, name = 'catalog-folder-pick' }) {
    const options = flatFolders(tree).filter((f) => !(exclude && exclude.has(f.id)));
    const row = (id, label, depth, icon, note) => {
        const checked = value === id;
        return (
            <label key={id} className={`flex items-center gap-2 min-h-[44px] pr-3 rounded-lg cursor-pointer text-sm ${checked ? 'bg-[#5F4EC9]/10 text-[#5F4EC9] font-semibold' : 'text-gray-700 hover:bg-gray-50'}`}
                style={{ paddingLeft: 12 + depth * 16 }}>
                <input type="radio" name={name} className="w-4 h-4 accent-[#5F4EC9]" checked={checked} onChange={() => onChange(id)} />
                {icon}
                <span className="truncate">{label}</span>
                {note && <span className="ml-auto text-xs text-gray-400 shrink-0">{note}</span>}
            </label>
        );
    };
    return (
        <div role="radiogroup" className="max-h-[50vh] overflow-y-auto border border-gray-200 rounded-lg p-1 space-y-0.5">
            {topLevel && row(TOP_LEVEL, 'Top level (no parent folder)', 0, <Layers size={16} className="shrink-0" />, hereId === TOP_LEVEL ? 'It’s here now' : null)}
            {options.map((f) => row(f.id, f.name, f.depth + (topLevel ? 1 : 0), <Folder size={16} className="shrink-0 text-gray-400" />, hereId === f.id ? 'It’s here now' : null))}
            {!options.length && !topLevel && <p className="p-3 text-sm text-gray-500">No folders yet. Make one with + in the folder column first.</p>}
        </div>
    );
}
